import React from "react";
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EmailButton, ResumeButton, PortfolioButton } from './Utilities';
import { faFacebook, faLinkedin, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';

const Home = () => {
    return (
        <div>
            <div className="header">
                <div className='main-left'>
                    <div className='main-left-top'>
                        <img src="main-img.png" alt="bio-pic" className='main-page-img' />
                    </div>
                    <div className='main-left-bottom'>
                        <h1 className='main-text' style={{ fontSize: '40px' }}>Rohit Narwal</h1>
                        <h2 className="main-text" style={{ fontSize: '18px' }}>Developer and Student</h2>
                        <EmailButton />
                    </div>
                </div>
                <div className='main-right'>
                    <div className="main-right-top">
                        <h1 className='main-text' style={{ backgroundColor: 'white', fontSize: '26px', margin: '0 0 5vh 0' }}>About ME <span role="img">😎</span></h1>
                        <hr style={{ textAlign: 'left', width: '43vw' }} />
                        <h4 className="main-text" style={{ backgroundColor: 'white', textAlign: 'left', margin: '3.5vh 0 12.5vh 0' }}>Hello! I'm Rohit Narwal, a passionate and highly motivated tech enthusiast based in Atlanta, GA. With a strong foundation in machine learning, data analysis, and AI applications, I thrive on solving complex problems and pushing the boundaries of technology.</h4>
                    </div>
                    <div className="main-right-bottom">
                        <div className="main-right-bottom-buttons">
                            <ResumeButton />
                            <PortfolioButton />
                        </div>
                        <div className="social-icons">
                            <a href="https://www.instagram.com/rawhit.narwal/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon className="icons" icon={faInstagram} size="2x" />
                            </a>
                            <a href="https://x.com/rawhit_narwal" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon className="icons" icon={faTwitter} size="2x" />
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=100078921545792" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon className="icons" icon={faFacebook} size="2x" />
                            </a>
                            <a href="https://www.linkedin.com/in/rohitnarwal/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon className="icons" icon={faLinkedin} size="2x" style={{margin:"20vh 0 20vh 20px"}}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;